import axios from "axios";
import React from "react";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { useNavigate } from "react-router";

export default function Uploadpayslipcom() {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    reset,
  } = useForm();
  const { mutate, isLoading, isError, isSuccess } = useMutation(
    (postData) => {
      axios.post(`${process.env.REACT_APP_HOST}/employee/upload`, postData)

    },
    {
      onSuccess: (data) => {
        console.log("User added successfully..", data);
        alert("Payslip Uploaded Sccessfullyy..")
        navigate("/DownloadPayslip")
        reset()
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
        alert("Failed to upload payslip")
        reset()
      },
    }
  );
  const onSubmit = (data) => {
    const formData = new FormData();
    formData.append("file", data?.file[0]);

    mutate(formData)
  };

  return (
    <div className="Uploadpayslipbg">
      <div className="Uploadform">

        <h6 className="uploadtext">Upload File</h6>
        <form onSubmit={handleSubmit(onSubmit)}>
          <input
            type="file"
            placeholder=""
            className="uploadinput"
            accept=".csv"
            {...register("file", { required: true })}
          />

          {errors.file && <p style={{ color: "red" }}>Please upload a file</p>}

          <div>
            <button
              className="uploadbutton"
              type="submit"

            >



              {isLoading ? (<><i class="fa fa-circle-o-notch fa-spin"></i> </>) : (<> Submit</>)}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
